goog.provide("shadow.js.shim.module$react_bootstrap$TabContainer$default");
shadow.js.shim.module$react_bootstrap$TabContainer$default = shadow.js.require(371, {}).default;
